<template>
    <div class="learningpath-banner-info">
        <div v-if="categories.length > 0" class="learningpath-banner-info__item">
            <span class="icon-book"></span>
            <span class="learningpath-banner-info__label" v-html="$t('General.categories')"></span>
            <div
                class="learningpath-banner-info__category-with-ancestors"
                :key="index"
                v-for="(categoryWithAncestors, index) in categories"
            >
                <span class="learningpath-banner-info__data -clickable"
                      v-for="(category, catIndex) in categoryWithAncestors"
                      :key="catIndex"
                      @click="goToListWithPreFilteredOption(category, 'categories')"
                >
                    <span>{{ category.label }}</span>
                    <template v-if="catIndex < categoryWithAncestors.length - 1"> > </template>
                </span>
                <template v-if="index < categories.length - 1">,</template>
            </div>
        </div>

        <div v-if="levels.length > 0" class="learningpath-banner-info__item">
            <span class="icon-stack"></span>
            <span class="learningpath-banner-info__label" v-html="$t('General.level')"></span>
            <span v-for="(level, index) in levelsObjectArray"
                  :key="index"
                  @click="goToListWithPreFilteredOption(level, 'difficulty_levels')"
            >
                <LearningPathBannerLevel :level="level"/>
            </span>
        </div>
        <div class="learningpath-banner-info__item -dates">
            <div class="highlight" v-if="lastUpdatedDate">
                <span class="learningpath-banner-info__label" v-html="$t('CourseDates.last_updated')"></span>
                <span class="learningpath-banner-info__data">{{ formattedDateForCountry(lastUpdatedDate) }}</span>
            </div>
            <div v-if="publishDate">
                <span class="learningpath-banner-info__label" v-html="$t('CourseDates.publish_date')"></span>
                <span class="learningpath-banner-info__data">{{ formattedDateForCountry(publishDate) }}</span>
            </div>
            <div v-if="expirationDate">
                <span class="learningpath-banner-info__label" v-html="$t('CourseDates.expiration_date')"></span>
                <span class="learningpath-banner-info__data">{{ formattedDateForCountry(expirationDate) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import goToListWithPreFilteredOption from 'components/shared/mixins/goToListWithPreFilteredOption'
    import LearningPathBannerLevel from 'components/learningpathpage/banner/LearningPathBannerLevel'
    import { formattedDateForCountry } from 'components/shared/mixins/dateHelper'

    export default {
        name: 'totem-learningpath-info',
        components: { LearningPathBannerLevel },
        mixins: [ goToListWithPreFilteredOption ],
        props: {
            categories: {
                type: Array,
                default: () => []
            },
            levels: {
                type: Array,
                default: () => []
            },
            publishDate: String,
            expirationDate: String,
            lastUpdatedDate: String
        },
        data () {
            return {
                showCategories: false
            }
        },
        computed: {
            levelsObjectArray () {
                return this.levels.map(el => ({
                    id: el,
                    label: el
                }))
            }
        },
        methods: {
            formattedDateForCountry
        }
    }
</script>

<style lang="scss" scoped>
    .learningpath-banner-info {
        display: flex;
        position: relative;
        font-size: 1.4rem;
        flex-direction: column;
        margin: 30px 0;
        padding: 5px;
        @include white(background, 0.4);
        width: 100%;

        [class*="icon-"] {
            margin: 0 10px 0 0;
        }

        &__item {
            position: relative;
            display: flex;
            padding: 5px;
            flex-wrap: wrap;

            &.-dates {
                .learningpath-banner-info__data  {
                    font-family: Nunito-ExtraBold, sans-serif;
                }
            }
        }

        &__label {
            padding: 0 10px 0 0;
        }

        &__data {
            font-family: Nunito-Bold, sans-serif;
            position: relative;

            &.-clickable {
                cursor: pointer;
            }
        }
        &__category-with-ancestors {
            padding-right: 5px;
        }

        &__category-with-ancestors:last-child {
            padding-right: 0;
        }

        .highlight {
            color: $chelsea_gem;
        }
    }
</style>
